import React, { useState } from 'react';
import { useTemplate } from '../../../../features/template/TemplateProvider';
import useApi from '../../../../hook/useApi';
import { ButtonCancel, ButtonPrimary } from '../../../../utils/Button';
import FocusControl from '../../../../utils/FocusControl';
import InputField from '../../../../utils/InputField';

function ModalAgencyInfoUpdate({ onReload }) {
    const { setMessage, modalData, closeModal } = useTemplate();
    const { put } = useApi();
    const [isError, setIsError] = useState('');
    const [loading, setLoading] = useState(false);

    const [formData, setFormData] = useState({
        Id: modalData?.id,
        FirstName: modalData.firstName || '',
        LastName: modalData.lastName || '',
        Organization: modalData.organization || '',
        PrimaryEmail: modalData.primaryEmail || '',
        PrimaryPhone: modalData.primaryPhone || ''
    });
    // -- Update Customer Handler
    const handleChange = (e) => {
        const { name, value } = e.target;
        if (name) {
            setFormData((d) => ({ ...d, [name]: value }));
        }
    };
    // -- Submit Update Customer Handler
    const handleUpdateCustomer = (e) => {
        setLoading(true);
        e.preventDefault();
        put(`/api/agency/${formData?.Id}`, formData)
            .then(({ error, message, referenceName }) => {
                if (error) {
                    setIsError(referenceName);
                    throw new Error(message);
                }
                onReload();
                closeModal();
                setMessage({ type: 'success', text: message });
            })
            .catch((ex) => {
                setMessage({ type: 'error', text: ex?.message });
            })
            .finally(() => {
                setLoading(false);
            });
    };

    // Focus Control on Error
    FocusControl(isError, setIsError, formData);

    return (
        <form onSubmit={handleUpdateCustomer} className="flex flex-col gap-4">
            <InputField
                label="Organization"
                name="Organization"
                placeholder='e.g. "Google"'
                formData={formData}
                onChange={handleChange}
                required
            />
            <div className="flex justify-between items-center gap-4">
                <InputField
                    label="First Name"
                    name="FirstName"
                    placeholder='e.g. "John"'
                    formData={formData}
                    onChange={handleChange}
                    required
                />
                <InputField
                    label="Last Name"
                    name="LastName"
                    placeholder='e.g. "Doe"'
                    formData={formData}
                    onChange={handleChange}
                    required
                />
            </div>
            <div className="flex justify-between items-center gap-4">
                <InputField
                    label="Email Address"
                    name="PrimaryEmail"
                    placeholder='e.g. mail@example.com"'
                    formData={formData}
                    onChange={handleChange}
                    required
                />
                <InputField
                    label="Phone Number"
                    name="PrimaryPhone"
                    placeholder='e.g. "+1 541 754 3010"'
                    formData={formData}
                    onChange={handleChange}
                    required
                />
            </div>
            <div className="w-full flex justify-end items-center gap-2 mb-2">
                <ButtonCancel title="Cancel" onClick={() => closeModal()} />
                <ButtonPrimary title="Update" btnType="submit" loading={loading} />
            </div>
        </form>
    );
}

export default ModalAgencyInfoUpdate;
